import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  addArray as addDocumentSourceArray,
  setCursor,
} from '../redux/documentSources'

export default function * fetchDocumentSources () {
  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  const state = yield select()

  const cursor = state.kanbo.documentSources.cursor

  const args = {
    limit: 20
  }

  if (cursor) {
    args.cursor = cursor
  }

  try {
    const { Sources: DocumentSources, Cursor } = yield call(apiGetData, 'AvailableDocumentsSources', args)

    const documentSources = []

    DocumentSources.forEach(DocumentSource => {
      const documentSource = {
        id: DocumentSource.Id,
        name: DocumentSource.Name,
        url: DocumentSource.Url
      }

      documentSources.push(documentSource)
    })

    yield put([
      addDocumentSourceArray(documentSources),
      setLoadStatus({
        isLoading: false,
        isLoaded: !Cursor
      }),
      setCursor(Cursor)
    ])
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))

    throw error
  }
}
